document.addEventListener(
    "DOMContentLoaded", () => {
        new Mmenu( "#mmenu", {
            "wrappers": [
                "wordpress"
            ],
            "extensions": [
                "pagedim-black",
                "position-right",
            ],
            "navbar": {
                "title": " ",
                "content": [
                    "close"
                ]
            },
            "keyboardNavigation": {
                "enable": "default",
                "enhance": true
            },
            "slidingSubmenus": true,
            "setSelected": {
                "hover": true,
                "parent": true
            },	
            "counters": false,
            "navbars": [
                {
                    "position": "top",
                    "content": [
                        "close",
                        mmenu_accessibility.topnav
                    ]
                },
                {
                    "position": "top",
                    "content": [
                        "searchfield"
                    ]
                }
            ],
            "searchfield": {
                "search": false,                                 
                "placeholder": mmenu_accessibility.search_menu,
                "noResults": mmenu_accessibility.no_results,
                "showSubPanels": false,	
                "panel": {
                    "add": true,
                    "dividers": true,
                    "title": mmenu_accessibility.search_menu,
                }
            }                                
        }, 
        {
            "searchfield": {
                form: {
                    action: "/",
                    method: "get" 
                },
                input: {
                    type: "text",
                    name: "s",
                    id: "mm-search" 
                }
            }
        });
    }
);